<template>
	<div class="tags-view-container">
		<!-- tags标签页 -->
		<scroll-pane ref="scrollPane" class="tags-view-wrapper">
			<el-tag :key="tag.path" 
			 ref="tag"
			type="info" 
			v-for="(tag,index) in tabList" :closable="tag.path!=='/'"
				:disable-transitions="false" @close="removeTab(tag)" @click="clickBtn(tag)"
				:class="($route.path === tag.path)?'active':''" class="tags-view-item" size="medium"
				:effect="$route.path === tag.path? 'dark' : 'plain'"
				@contextmenu.prevent.native="openContextmenu(tag,$event)">
				{{tag.title}}
			</el-tag>
		</scroll-pane>
		<ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
			<li @click="closeSelectedTag">关闭当前</li>
			<li @click="closeOthersTags">关闭其它</li>
			<li @click="closeAllTags">全部关闭</li>
		</ul>
	</div>
</template>

<script>
	import ScrollPane from './ScrollPane'
	import store from '../../store'
	export default {
		name: '',
		data() {
			return {
				top: 0,
				left: 0,
				activeTab: '',
				visible: false,
				selectTab: ''
			}
		},
		components: {
			ScrollPane
		},
		computed: {
			tabList() {
				return store.getters['tabsModule/getTabs']
			},
		},
		watch: {
			$route: function() {
				this.setActiveTab()
				this.addTab()
				this.moveToCurrentTag()
			},
		},
		created() {
			
		},
		mounted() {
			this.beforeRefresh()
			this.setActiveTab()
			this.addTab()			
			//this.moveToCurrentTag()			
		},
		methods: {
			openContextmenu(tag, e) {
				const menuMinWidth = 105
				const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
				const offsetWidth = this.$el.offsetWidth // container width
				const maxLeft = offsetWidth - menuMinWidth // left boundary
				const left = e.clientX - offsetLeft + 190 // 15: margin right			     
				if (left > maxLeft) {
					this.left = maxLeft
				} else {
					this.left = left
				}
				this.top = e.clientY + 20
				this.visible = !this.visible
				this.selectTab = tag.path //前tabs页面的path
			},
			closeSelectedTag(e) {
				if (this.tabList.length === 1) {
					return
				}
				const tabs = this.tabList
				let active = this.activeTab
				if (this.visible) {
					this.visible = false					
					if (this.selectTab == this.activeTab) {
						this.tabList.forEach((tab, index) => {
							if (tab.path === active) {
								// 如果删除的就是当前活跃的tab,就把活跃的tab变成上一个或下一个
								const nextTab = this.tabList[index - 1] || this.tabList[index + 1]
								if (nextTab) {
									active = nextTab.path
								}
							}
						})
						this.activeTab=active;
						this.$router.push({
							path: active
						})
					}
					store.state.tabsModule.tabList = tabs.filter((tab) => tab.path !== this.selectTab)					
				}				
			},
			closeOthersTags() {
				if (this.tabList.length === 1) {
					return
				}
				const tabs = this.tabList
				if (this.visible) {
					store.state.tabsModule.tabList = tabs.filter(f => {
						/* 除了它以外的都不要 */
						return f.path === this.selectTab || f.path === '/' //保留当前页和首页
					})
					this.visible = false
					this.$router.push({
						path: this.selectTab
					})
				}
			},
			closeAllTags() {
				if (this.tabList.length === 1) {
					return
				}
				const tabs = this.tabList
				if (this.visible) {
					store.state.tabsModule.tabList = tabs.filter((tab) => tab.path == '/')
					this.visible = false
					this.$router.push({
						path: '/'
					})
				}
			},
			// 设置活跃的tab
			setActiveTab() {
				this.activeTab = this.$route.path
				//this.moveToCurrentTag()
			},
			// 添加tab
			addTab() {
				const {
					path,
					meta
				} = this.$route
				const tab = {
					path,
					title: meta.title,
				}
				store.commit('tabsModule/addTab', tab)
				//console.log(this.$refs.tag[0].$route.fullPath)
				 
			},
			// 点击tab
			clickBtn(tab) {
				this.$router.push({
					path: tab.path
				})
			},
			// 删除tab
			removeTab(tag) {
				//首页禁止删除
				if (tag.path === '/') return
				// 当前激活的tab					
				let active = this.activeTab
				const tabs = this.tabList
				// 只有一个标签页的时候不允许删除
				if (tabs.length === 1) return				
				if (tag.path === active) {//如果删除的是当前页
					this.tabList.forEach((tab, index) => {
						if(active === tab.path){
							// 如果删除的就是当前活跃的tab,就把活跃的tab变成上一个或下一个
							const nextTab = this.tabList[index - 1]||this.tabList[index +1]
							if (nextTab) {
								active = nextTab.path
							}							
						}
					})	
					this.activeTab = active
					this.$router.push({
						path: active
					})				
				}
				// 重新设置当前激活的选项卡和 选项卡列表
				store.state.tabsModule.tabList = tabs.filter((tab) => tab.path !== tag.path)				
			},
			// 解决刷新数据丢失问题
			beforeRefresh() {
				window.addEventListener('beforeunload', () => {
					sessionStorage.setItem('tabsView', JSON.stringify(this.tabList))
				})
				let tabSession = sessionStorage.getItem('tabsView')
				if (tabSession) {
					let oldTabs = JSON.parse(tabSession)
					if (oldTabs.length > 0) {
						store.state.tabsModule.tabList = oldTabs
					}
				}
			},
			closeMenu() {
			  this.visible = false
			},
			moveToCurrentTag() {
			  const tags = this.$refs.tag
			  this.$nextTick(() => {
			    for (const tag of tags) {
					//console.log(tag.$el)	
			      if (tag.$route.fullPath === this.$route.path) {
			        this.$refs.scrollPane.moveToTarget(tag)								   
			        //break
			      }
			    }
			  })
			},
		},
	}
</script>
<style lang="less">
	.tags-view-container {
		height: 34px;
		width: 100%;
		background: #fff;
		border-bottom: 1px solid #d8dce5;
		box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .12), 0 0 1px 0 rgba(0, 0, 0, .04);

		.tags-view-wrapper {
			.tags-view-item {
				display: inline-block;
				position: relative;
				cursor: pointer;
				height: 28px;
				line-height: 26px;
				border: 1px solid #d8dce5;
				color: #495060;
				background: #fff;
				padding: 0 8px;
				font-size: 12px;
				margin-left: 5px;
				margin-top: 1px;
				border-radius: 0px;

				&:first-of-type {
					margin-left: 15px;
				}

				&:last-of-type {
					margin-right: 15px;
				}

				&.active {
					background-color:#409EFF;//当前主题色
					color: #fff;
					border-color:#409EFF;

					&::before {
						content: '';
						background: #fff;
						display: inline-block;
						width: 8px;
						height: 8px;
						border-radius: 50%;
						position: relative;
						margin-right: 2px;
					}
				}

				.el-icon-close {
					width: 16px;
					height: 16px;
					vertical-align: 2px;
					border-radius: 50%;
					text-align: center;
					transition: all .3s cubic-bezier(.645, .045, .355, 1);
					transform-origin: 100% 50%;

					&:before {
						transform: scale(.6);
						display: inline-block;
						vertical-align: -3px;
					}

					&:hover {
						background-color: #b4bccc;
						color: #fff;
					}
				}
			}
		}
		.contextmenu {
			margin: 0;
			background: #fff;
			z-index: 3000;
			position: absolute;
			list-style-type: none;
			padding: 5px 0;
			border-radius: 4px;
			font-size: 12px;
			font-weight: 400;
			color: #333;
			box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
			li {
				margin: 0;
				padding: 7px 16px;
				cursor: pointer;
				&:hover {
					background: #eee;
				}
			}
		}
	}
</style>